// extracted by mini-css-extract-plugin
export default {"provider-card-header":"_2EmBOD_uyE0Rle3ZoVFzTh","provider-card-header__image":"_3ErslTHueKqSHtxsE9kydO","provider-card-header__content":"_1Zo09q7LERwMDU_q5o3wIs"};